<template>
  <div class="container my-2 mrl-2">
    <div id="mapid"></div>
  </div>
</template>

<script>
export default {
  props: ["coordinates"],
  data() {
    return {
      map: {},
      marker: null,
      latlng: this.coordinates,
    };
  },
  methods: {
    logLangLat: function (e) {
      this.$emit("selected", e.latlng);
      this.latlng = e.latlng;
      if (this.marker) {
        this.marker.setLatLng(e.latlng);
      } else {
        this.createMarker();
      }
    },

    createMap: function () {
      /* eslint-disable  */
      let map = L.map("mapid", {
        crs: L.CRS.Simple,
        maxZoom: 1,
        minZoom: -2,
      });
      let bounds = [
        [0, 0],
        [3684, 4000],
      ];
      let image = L.imageOverlay("/images/main/mappl.jpg", bounds).addTo(map);
      map.setView([1842, 2000], -2);
      this.map = map;
      return map;
    },
    getTooltipTemplate: function (title) {
      return `<span class='map-tooltip'>${title}</span>`;
    },
    createMarker: function () {
      /* eslint-disable  */
      if (this.latlng && this.latlng.lat && this.latlng.lng) {
        let point = L.latLng([this.latlng.lat, this.latlng.lng]);
        let marker = L.marker(point).addTo(this.map);
        this.marker = marker;
      }
      //  .bindTooltip(this.getTooltipTemplate(building.title));
      // marker.on("click", () => this.navigate(building.slug));
    },
  },
  created() {},
  mounted() {
    this.createMap();
    this.createMarker();
    this.map.on("click", this.logLangLat);
  },

  watch: {
    coordinates: function (newVal, oldVal) {
      if (!newVal || !newVal.lat || !newVal.lng) {
        if (this.marker) {
          this.map.removeLayer(this.marker);
          this.marker = null;
        }
        return;
      }
      this.latlng = newVal;
      if (this.marker) {
        this.marker.setLatLng(this.latlng);
      } else {
        this.createMarker();
      }
      this.map.setView([this.latlng.lat, this.latlng.lng], -1);
    },
  },
};
</script>
<style >
#mapid {
  height: 600px;
  width: auto;
}
.leaflet-control-attribution.leaflet-control {
  display: none;
}
.leaflet-popup-close-button {
  display: none;
}
.map-tooltip {
  font-size: 16px;
}
</style>